import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AdminHeader from '../../components/admin/AdminHeader';
import { logError } from '../../utils/apiError';
import authService from '../../services/authService';

const AccountPage = () => {
  const [adminUser, setAdminUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('AccountPage - Component mounted, current path:', window.location.pathname);
    
    // Check if user is logged in as admin using authService
    if (!authService.isAdminLoggedIn()) {
      console.log('AccountPage - Not authenticated, redirecting to login');
      navigate('/admin/login');
      return;
    }
    
    // Get admin user data from authService
    const userData = authService.getAdminUser();
    
    if (!userData) {
      console.log('AccountPage - No admin user data, redirecting to login');
      navigate('/admin/login');
      return;
    }
    
    console.log('AccountPage - User data:', userData);
    setAdminUser(userData);
    
    // Prevent unexpected redirects
    const preventRedirect = () => {
      const currentPath = window.location.pathname;
      if (currentPath !== '/admin/account') {
        console.log(`AccountPage - Detected path change to ${currentPath}, preventing redirect`);
        window.history.pushState({}, '', '/admin/account');
      }
    };
    
    // Add event listener for path changes
    window.addEventListener('popstate', preventRedirect);
    
    return () => {
      window.removeEventListener('popstate', preventRedirect);
    };
  }, [navigate]);

  if (!adminUser) return <div>Loading...</div>;

  // Styles
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginBottom: '20px'
  };

  const headerStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    marginBottom: '15px',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '10px'
  };

  const infoRowStyle = {
    display: 'flex',
    padding: '10px 0',
    borderBottom: '1px solid #f3f4f6'
  };

  const labelStyle = {
    fontWeight: '500',
    width: '200px'
  };

  const valueStyle = {
    flex: '1'
  };

  const buttonStyle = {
    display: 'inline-block',
    backgroundColor: '#4f46e5',
    color: 'white',
    fontWeight: '500',
    padding: '10px 16px',
    borderRadius: '6px',
    textDecoration: 'none',
    marginTop: '20px'
  };

  return (
    <div>
      <AdminHeader adminUser={adminUser} />
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '20px' 
      }}>
        <h2 style={{ 
          margin: '0 0 8px 0', 
          fontSize: '28px', 
          color: '#111827' 
        }}>
          Account Settings
        </h2>
        <p style={{ 
          margin: '0 0 24px 0', 
          fontSize: '14px', 
          color: '#6b7280' 
        }}>
          Manage your profile and security settings
        </p>
      
        <div style={cardStyle}>
          <h3 style={headerStyle}>Profile Information</h3>
        
          <div style={infoRowStyle}>
            <div style={labelStyle}>Name</div>
            <div style={valueStyle}>{adminUser.name || 'Not set'}</div>
          </div>
        
          <div style={infoRowStyle}>
            <div style={labelStyle}>Email</div>
            <div style={valueStyle}>{adminUser.email}</div>
          </div>
        
          <div style={infoRowStyle}>
            <div style={labelStyle}>Role</div>
            <div style={valueStyle}>{adminUser.role || 'Standard'}</div>
          </div>
        </div>
      
        <div style={cardStyle}>
          <h3 style={headerStyle}>Security</h3>
          <p>Manage your account security settings and update your password.</p>
        
          <Link to="/admin/change-password" style={buttonStyle}>
            Change Password
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;